<script>
import UserUtils from '@/helpers/users';
import isEmpty from "is-empty";
import countriesISO from "i18n-iso-countries";


export default {
  name: "ModalWriteUser",
  props: {
    user: {
      type: Object,
    },

    visible: {
      type: Boolean,
      default: () => {
        return false
      }
    },

    sending: {
      type: Boolean,
      default: () => {
        return false
      }
    },

    msg: {
      type: String,
      default: () => {
        return ""
      }
    }
  },
  watch: {
    user: {
      handler: function (value) {
        this.userObject = {...this.userObject, ...value };
        if (!isEmpty(this.userObject.photoUrl)) {
          this.userIcon = this.userObject.photoUrl;
        }
      },
      immediate: true
    },

    visible: {
      handler: function (value) {
        if (value) {
          this.$bvModal.show('modal-write-user');
        }
        else {
          this.$bvModal.hide('modal-write-user');
        }
      },
      immediate: true
    },

    sending: {
      handler: function (value) {
        this.isSending = value;
      },
      immediate: true
    },

    msg: {
      handler: function (value) {
        this.message = value;
      },
      immediate: true
    }
  },
  data() {
    return {
      isSending: false,
      userObject: {
        userId: '',
        photoUrl: '',
        name: this.$t("user.unknown"),
        birth: '',
        age: '',
        country: '',
        locality: '',
        sex: 0,
      },
      userIcon: require('@/assets/images/users/default-user.png'),
      message: "",
      sendAs: {
        mail: false,
        app: false,
      }
    };
  },

  methods: {
    ...UserUtils,

    closeModal() {
      this.$emit("closeModalWriteUser", this.message);
    },
    sendMessage() {
      this.$emit("sendMessageWriteUser", this.message, this.sendAs);
    }
  },

  computed: {
    getCountry() {
      return UserUtils.getCountryName(countriesISO, this.userObject.country.toUpperCase(), this.$i18n.locale)
    }
  },

  created() {
    countriesISO.registerLocale(require("i18n-iso-countries/langs/"+this.$i18n.locale+".json"));
  }
}
</script>

<template>
  <b-modal id="modal-write-user">
    <template #modal-header="{ close }">
      <div class="d-flex align-items-center">
        <img :src="userIcon" alt="" class="rounded-circle avatar-sm" />
        <div class="ms-3">
          <p class="font-size-11 text-muted mb-0">
            <small v-if="userObject.userId !== ''">#{{ userObject.userId }}</small><small v-else-if="userObject.originalUserId !== ''">#{{ userObject.originalUserId }}</small>
          </p>
          <p class="font-size-13 text-muted mb-0">
            <b>{{ userObject.name }}</b> {{ getAge(userObject.birth) }} <img :src="getGenderImg(userObject.sex)" width="16" height="16" alt=""/>
            <br>{{ userObject.email }}
            <span v-if=" userObject.locality !== ''"><br><country-flag :country='userObject.country' size='small'/> {{ userObject.locality }}, {{ getCountry }}</span>
          </p>
        </div>
      </div>
    </template>

    <template #default>
      <b-form-textarea
          id="replyText"
          v-model="message"
          class="mt-2 font-size-13 mb-2"
          max-rows="15"
          style="height: 250px"
      ></b-form-textarea>
      <div class="d-flex align-items-center justify-content-center p-2">
        <span class="me-2 mb-2"><b>Send as:</b></span>
        <b-form-checkbox
            v-model="sendAs.mail"
            id="sendMail"
            class="form-check me-2"
        >{{ $t("writeModal.send_as_mail") }}</b-form-checkbox>
        <b-form-checkbox
            v-model="sendAs.app"
            id="sendMessage"
            class="form-check"
        >{{ $t("writeModal.send_as_app_message") }}</b-form-checkbox>
      </div>

    </template>

    <template #modal-footer="{ ok, cancel }">
      <vue-ellipse-progress
          v-show="isSending"
          :loading="isSending"
          :angle="-90"
          color="#50a5f1"
          emptyColor="#999"
          emptyColorFill="#f8f8fb"
          :size="40"
          :thickness="3"
          :emptyThickness="2"
          lineMode="out 2"
          animation="bounce 700 400"
          fontColor="#666"
          :half="false"
          class="mt-5 mb-5"
          fontSize="1rem">
      </vue-ellipse-progress>
      <b-button v-show="!isSending" @click="closeModal" variant="danger">{{ $t("cancel") }}</b-button>
      <b-button v-show="!isSending" @click="sendMessage" variant="primary">{{ $t("valid") }}</b-button>
    </template>

  </b-modal>

</template>

<style lang="scss" scoped>

</style>